import {F_PREFFERENCE} from '../components/secondStep/constants';

const settings = window?.drupalSettings || {}

export const commonWordings = settings.commonWordings || {}

export const filterMoreWordings = settings?.widgets?.filters?.more;
export const filterSortWordings = settings?.widgets?.filters?.sort;

export const queryParameters = settings?.path?.currentQuery;

export const detailInfoBlock = settings?.booking?.secondStep?.detailInfoBlock;
export const preferenceData = settings?.booking?.secondStep?.yourDataBlock?.blockForm?.fields?.[F_PREFFERENCE] || null;

export const offersMockedData = settings?.search?.offer || {};

export default settings;
